"use client";
import {
	Calendar03Icon,
	Location01Icon,
	Medal01Icon,
	Task01Icon,
	UserCircleIcon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { motion } from "motion/react";
import { Card } from "@/components/ui/card";

const FEATURES = [
	{
		title: "Public player profile",
		description:
			"A handle, a face, your match record. Share one link with anyone.",
		icon: UserCircleIcon,
	},
	{
		title: "District-first tournament browse",
		description:
			"See tournaments in your district first, plus state and national events.",
		icon: Calendar03Icon,
	},
	{
		title: "Browse local venues",
		description:
			"Find courts and grounds near you with sports, hours, and capacity.",
		icon: Location01Icon,
	},
	{
		title: "Match history and certificates",
		description:
			"Every match you play, every certificate you earn, all kept in one place.",
		icon: Medal01Icon,
	},
	{
		title: "Fill it once",
		description:
			"One profile feeds every registration. No more rewriting your details.",
		icon: Task01Icon,
	},
];

export function FeaturesSection() {
	// Duplicate the list 3 times so the marquee scroll is seamless
	const duplicatedFeatures = [...FEATURES, ...FEATURES, ...FEATURES];

	return (
		<section className="section-spacing w-full overflow-hidden border-border/40 border-y bg-muted/20">
			<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
				<div className="mb-16 flex flex-col items-center justify-center space-y-4 text-center">
					{/* <p className="font-mono font-semibold text-primary text-sm uppercase tracking-[0.2em]">
						The Player Experience
					</p> */}
					<h2 className="font-semibold text-4xl tracking-tight md:text-5xl">
						Built for players
					</h2>
					{/* <p className="max-w-4xl text-pretty text-lg text-muted-foreground">
						Find tournaments near you, register in seconds, track your match
						record.
					</p> */}
				</div>
			</div>

			<div className="relative w-full [mask-image:linear-gradient(to_right,transparent,black_5%,black_95%,transparent)]">
				<motion.div
					className="flex w-max items-stretch gap-6 py-4 pl-6 lg:gap-8 lg:pl-8"
					animate={{
						x: ["0%", "-33.333333%"],
					}}
					transition={{
						repeat: Number.POSITIVE_INFINITY,
						ease: "linear",
						duration: 35,
					}}
				>
					{duplicatedFeatures.map((feature, idx) => (
						<Card
							key={`${feature.title}-${idx}`}
							className="group relative w-[300px] shrink-0 gap-5 p-8 transition-colors hover:bg-muted/40 md:w-[380px]"
						>
							<div className="absolute top-0 right-0 -mt-8 -mr-8 h-32 w-32 rounded-full bg-primary/5 blur-3xl transition-all duration-500 group-hover:bg-primary/10" />

							<div className="relative z-10 flex flex-col gap-5">
								<div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-transform duration-300 group-hover:scale-110">
									<HugeiconsIcon icon={feature.icon} className="h-7 w-7" />
								</div>
								<div className="space-y-2">
									<h3 className="font-semibold text-xl tracking-tight">
										{feature.title}
									</h3>
									<p className="text-pretty text-muted-foreground leading-relaxed">
										{feature.description}
									</p>
								</div>
							</div>
						</Card>
					))}
				</motion.div>
			</div>
		</section>
	);
}
